import script from "./BowlerResultsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BowlerResultsView.vue?vue&type=script&lang=ts&setup=true"

import "./BowlerResultsView.vue?vue&type=style&index=0&id=84d9d74a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84d9d74a"]])

export default __exports__